export const urls = {
	orders: {
		regions: '/sber_mq/region',
		externalForm: 'sber_mq/external_form',
	},
	cabinet: {
		inn: 'rbidos_request/inn',
	},
	landings: {
		leadCreate: '/lead/',
		agreementModel: '/agreement/by_key/sber_mq__external_form/main',
	},
}
